import React from "react";
import styled from "styled-components";
import { Link, NavLink, useLocation } from "react-router-dom";
// import { FiArrowRight } from "react-icons/fi";

const Header = ({ toggleMenu }) => {
  const location = useLocation();

  const aboutActive = [
    "/about",
    "/team",
    "/chairman-msg",
    "/md-msg",
    "/directors",
    "/administrative",
  ].includes(location.pathname);

  const messageActive = ["/chairman-msg", "/md-msg"].includes(
    location.pathname,
  );

  const netRoopActive = [
    "/fishing-net",
    "/agri_net",
    "/garden_net",
    "/build_net",
    "/pp-rope",
    "/hdpe-rope",
  ].includes(location.pathname);

  const netActive = [
    "/fishing-net",
    "/agri_net",
    "/garden_net",
    "/build_net",
  ].includes(location.pathname);

  const ropeActive = ["/pp-rope", "/hdpe-rope"].includes(location.pathname);

  const mediaActive = ["/news", "/gallery", "/video"].includes(
    location.pathname,
  );

  const policyActive = ["/bepza_act", "/labor_law"].includes(location.pathname);

  return (
    <Wrapper>
      <header>
        {/* ====== Sticky Header ====== */}
        <div
          className="rs-header-area rs-header-one rs-sticky-header"
          id="rs-sticky-header"
        >
          <div className="container-fluid g-0">
            <div className="rs-header-inner">
              <div className="rs-header-left">
                <div className="rs-header-logo-wrapper">
                  <div className="rs-header-logo">
                    <Link to="/">
                      <img
                        // src="/assets/images/logo/logo-orange.png"
                        src="/assets/images/logo/eque international.png"
                        alt="logo"
                        style={{ width: "364px", height: "64px" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="rs-header-menu">
                <nav id="mobile-menu" className="main-menu">
                  <ul className="multipage-menu">
                    <li className="has-mega-menu">
                      <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Home
                      </NavLink>
                    </li>

                    <li
                      className={`menu-item-has-children ${
                        aboutActive ? "active" : ""
                      }`}
                    >
                      <Link to="#" className={aboutActive ? "active" : ""}>
                        About
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/about">About Eque International</NavLink>
                        </li>

                        <li>
                          <NavLink to="/team">Our Management Team</NavLink>
                        </li>

                        <li
                          className={`has-arrow ${messageActive ? "active" : ""}`}
                        >
                          <Link
                            to="#"
                            className={messageActive ? "active" : ""}
                          >
                            Massages
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/chairman-msg">
                                Massages From Chairman
                              </NavLink>
                            </li>

                            <li>
                              <NavLink to="/md-msg">Massages From MD</NavLink>
                            </li>
                          </ul>
                        </li>

                        <li>
                          <NavLink to="/directors">Board Of Directors</NavLink>
                        </li>

                        <li>
                          <NavLink to="/administrative">
                            Administrative Officer
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={`menu-item-has-children ${
                        netRoopActive ? "active" : ""
                      }`}
                    >
                      <Link to="#" className={netRoopActive ? "active" : ""}>
                        Net & Roop
                      </Link>

                      <ul className="submenu last-children">
                        <li
                          className={`has-arrow ${netActive ? "active" : ""}`}
                        >
                          <Link to="#" className={netActive ? "active" : ""}>
                            Net's
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/fishing-net">Fishing Net</NavLink>
                            </li>

                            <li>
                              <NavLink to="/agri_net">Agriculture Net</NavLink>
                            </li>
                            <li>
                              <NavLink to="/garden_net">Garden Net</NavLink>
                            </li>
                            <li>
                              <NavLink to="/build_net">
                                Building Safety Net
                              </NavLink>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`has-arrow ${ropeActive ? "active" : ""}`}
                        >
                          <Link to="#" className={ropeActive ? "active" : ""}>
                            Roop's
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/pp-rope">PP Danline Rope</NavLink>
                            </li>

                            <li>
                              <NavLink to="/hdpe-rope">
                                HDPE Twine & Rope
                              </NavLink>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <NavLink
                        to="/products"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Products
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/awards"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Awards
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/certification"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Certification
                      </NavLink>
                    </li>

                    <li
                      className={`menu-item-has-children ${mediaActive ? "active" : ""}`}
                    >
                      <Link to="#" className={mediaActive ? "active" : ""}>
                        Media
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/news">News & Events</NavLink>
                        </li>

                        <li>
                          <NavLink to="/gallery">Gallery</NavLink>
                        </li>

                        {/* <li>
                          <NavLink to="/video">Video</NavLink>
                        </li> */}
                      </ul>
                    </li>

                    <li
                      className={`menu-item-has-children ${policyActive ? "active" : ""}`}
                    >
                      <Link to="#" className={policyActive ? "active" : ""}>
                        Act & Policies
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/bepza_act">BEPZA Act</NavLink>
                        </li>

                        <li>
                          <NavLink to="/labor_law">EPZ Labor Law</NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink
                        to="/contact"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Contact
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="rs-header-right">
                <div className="rs-theme-social has-transparent has-orange">
                  <Link to="#">
                    <i className="ri-twitter-x-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-facebook-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-instagram-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                </div>

                <div className="rs-header-hamburger">
                  <div className="sidebar-toggle" onClick={toggleMenu}>
                    <Link className="bar-icon" to="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ====== Main Header ====== */}
        <div className="rs-header-area rs-header-one">
          <div className="container-fluid g-0">
            <div className="rs-header-inner">
              <div className="rs-header-left">
                <div className="rs-header-logo-wrapper">
                  <div className="rs-header-logo">
                    <Link to="/">
                      <img
                        // src="/assets/images/logo/logo-orange.png"

                        src="/assets/images/logo/eque international.png"
                        alt="logo"
                        style={{ width: "364px", height: "64px" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="rs-header-menu">
                <nav id="mobile-menu-two" className="main-menu">
                  <ul className="multipage-menu">
                    <li className="">
                      <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Home
                      </NavLink>
                    </li>

                    <li
                      className={`menu-item-has-children ${
                        aboutActive ? "active" : ""
                      }`}
                    >
                      <Link to="#" className={aboutActive ? "active" : ""}>
                        About
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/about">About Eque International</NavLink>
                        </li>

                        <li>
                          <NavLink to="/team">Our Management Team</NavLink>
                        </li>

                        <li
                          className={`has-arrow ${messageActive ? "active" : ""}`}
                        >
                          <Link
                            to="#"
                            className={messageActive ? "active" : ""}
                          >
                            Massages
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/chairman-msg">
                                Massages From Chairman
                              </NavLink>
                            </li>

                            <li>
                              <NavLink to="/md-msg">Massages From MD</NavLink>
                            </li>
                          </ul>
                        </li>

                        <li>
                          <NavLink to="/directors">Board Of Directors</NavLink>
                        </li>

                        <li>
                          <NavLink to="/administrative">
                            Administrative Officer
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={`menu-item-has-children ${
                        netRoopActive ? "active" : ""
                      }`}
                    >
                      <Link to="#" className={netRoopActive ? "active" : ""}>
                        Net & Roop
                      </Link>

                      <ul className="submenu last-children">
                        <li
                          className={`has-arrow ${netActive ? "active" : ""}`}
                        >
                          <Link to="#" className={netActive ? "active" : ""}>
                            Net's
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/fishing-net">Fishing Net</NavLink>
                            </li>

                            <li>
                              <NavLink to="/agri_net">Agriculture Net</NavLink>
                            </li>
                            <li>
                              <NavLink to="/garden_net">Garden Net</NavLink>
                            </li>
                            <li>
                              <NavLink to="/build_net">
                                Building Safety Net
                              </NavLink>
                            </li>
                          </ul>
                        </li>

                        <li
                          className={`has-arrow ${ropeActive ? "active" : ""}`}
                        >
                          <Link to="#" className={ropeActive ? "active" : ""}>
                            Roop's
                          </Link>

                          <ul className="submenu">
                            <li>
                              <NavLink to="/pp-rope">PP Danline Rope</NavLink>
                            </li>

                            <li>
                              <NavLink to="/hdpe-rope">
                                HDPE Twine & Rope
                              </NavLink>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                    <li className="">
                      <NavLink
                        to="/products"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Products
                      </NavLink>
                    </li>
                    <li className="">
                      <NavLink
                        to="/awards"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Awards
                      </NavLink>
                    </li>
                    <li className="">
                      <NavLink
                        to="/certification"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Certification
                      </NavLink>
                    </li>

                    <li
                      className={`menu-item-has-children ${mediaActive ? "active" : ""}`}
                    >
                      <Link to="#" className={mediaActive ? "active" : ""}>
                        Media
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/news">News & Events</NavLink>
                        </li>

                        <li>
                          <NavLink to="/gallery">Gallery</NavLink>
                        </li>

                        {/* <li>
                          <NavLink to="/video">Video</NavLink>
                        </li> */}
                      </ul>
                    </li>
                    <li
                      className={`menu-item-has-children ${policyActive ? "active" : ""}`}
                    >
                      <Link to="#" className={policyActive ? "active" : ""}>
                        Act & Policies
                      </Link>

                      <ul className="submenu last-children">
                        <li>
                          <NavLink to="/bepza_act">BEPZA Act</NavLink>
                        </li>

                        <li>
                          <NavLink to="/labor_law">EPZ Labor Law</NavLink>
                        </li>
                      </ul>
                    </li>

                    <li className="">
                      <NavLink
                        to="/contact"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Contact
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="rs-header-right">
                <div className="rs-theme-social has-transparent has-orange">
                  <Link to="#">
                    <i className="ri-twitter-x-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-facebook-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-instagram-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                </div>

                <div className="rs-header-hamburger">
                  <div className="sidebar-toggle" onClick={toggleMenu}>
                    <Link className="bar-icon" to="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .rs-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    margin-left: auto;
  }

  /* 🔥 Active menu color */
  .main-menu a.active {
    color: #ff5c00 !important;
  }

  /* Optional hover effect */
  .main-menu a:hover {
    color: #ff5c00;
  }

  .rs-header-one .main-menu {
    /* border-inline-start: 1px solid rgba(31, 31, 31, 0.07); */
    border-inline-start: none !important;
  }

  .main-menu a.active,
  .main-menu li.active > a {
    color: #ff5c00 !important;
  }

  /* ===== Desktop (>1024px) ===== */
  @media (min-width: 1025px) {
    .rs-header-hamburger {
      display: none; /* hide hamburger */
    }

    .rs-header-menu {
      display: block; /* show menu */
    }
  }

  /* ===== Tablet + Mobile (≤1024px) ===== */
  @media (max-width: 1024px) {
    .rs-sticky-header .rs-header-menu {
      display: none !important; /* hide menu */
    }

    .rs-sticky-header .rs-header-hamburger {
      display: block !important; /* show hamburger */
    }

    .rs-header-hamburger {
      display: block;
    }
  }
`;

export default Header;


